/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { useLoggedInUser } from '@dai/common'
import { DAIPermissionEnum } from '@dai/graphql'

export const usePermissions = () => {
  const { state: loggedInUser } = useLoggedInUser('gnarnia')

  const userPermissions = loggedInUser.user?.permissions ?? []

  const permissions = Object.values(DAIPermissionEnum).reduce(
    (acc, permission) => ({
      ...acc,
      [permission]: userPermissions.some(p => p.codename === permission),
    }),
    {} as Record<DAIPermissionEnum, boolean>,
  )

  const hasPermission = (codename: string) =>
    userPermissions.some(p => p.codename === codename)

  return {
    permissions,
    hasPermission,
    loading: loggedInUser.loading,
  }
}
